import React, { useState, useRef, useEffect } from 'react';
import { OtrosImpuestos } from '../hacienda/caja/modalOtroPago';
import PagosRegistros from '../hacienda/caja/registrarpagos';
import axios from 'axios';

import { Mensaje } from '../../components/mensajes2';

import { Dimmer} from "../../components/spinner";

import moment from 'moment';
import { FacturaMultaPago } from '../hacienda/caja/modalFactMultaPago';
import { TasasPagos } from '../hacienda/caja/modalFacturaTasasPagos';
import { FacturaPublicidadPago } from '../hacienda/caja/modalFacturaPublicidadPago';
import { validaSoloNumero, formatMoneda } from '../../util/varios';
import { Input, Radio } from '../../ui/inputs/Input';
import { FacturaPago } from '../hacienda/caja/modalFacturaPago';

function CajaIngresosCastatro() {

  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  // const [titulo, setTitulo] = useState();
  const [visibleNumAte, setVisibleNunAte] = useState('hidden');

  const [factorCambio, setFactorCambio] = useState(0)

  const [idtipoimpuesto, setIdtipoimpuesto] = useState(null);
  const [idtipoimpuestos, setIdtipoimpuestos] = useState(null);
  const [tipoImpuesto, setTipoImpuesto] = useState(null);
  const [valor, setValor] = useState(null);
  const [numCaja, setNumCaja] = useState(JSON.parse(localStorage.getItem('numcaja')));
  const [facturas, setFacturas] = useState([]);
  const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
  const idusuario = JSON.parse(localStorage.getItem('idusuario'));

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  // const radioFactu = useRef();
  // const radioVerifi = useRef();
  const [activo, setActivo] = useState(false);
  const [mostrarFacturaMulta, setMostrarFacturaMulta] = useState(false);
  const [mostarTasasP, setMostrarTasasP] = useState(false);
  const [mostrarPublicidad, setMostrarPublicidad] = useState(false);
  // const [mostrarLicores, setMostrarLicores] = useState(false);

  const radioReg = useRef();
  const radioEsp = useRef();
  const radioVip = useRef();
  const txtNumAtencion = useRef();


  var op = require('../../modulos/datos')
  let token = localStorage.getItem('jwtToken');

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem('post'));
    setNumCaja(obj.numCaja);
    // radioFactu.current.checked = true;
    //radioVerifi.current.checked = false;
    seleccionarFacturas();
    seleccionarFactorCambio()
  }, []);

  const cargarpago = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === '' || numCaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setValor(valor);
    setMostrar(true);

  }

  const seleccionarFactorCambio = () => {

    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        console.log(response.data)
        setFactorCambio(response.data.valor)

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const cargarotropago = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === '' || numCaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrar2(true);

  }

  const cargaroFacturaMulta = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === '' || numCaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrarFacturaMulta(true);

  }

  const cargarpago2 = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === '' || numCaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuestos(tipo);
    setTipoImpuesto(tipoimpu);

    setMostrarTasasP(true);


  }

 /*  const cargaroTasasPago = () => (e) => {
    

  } */

  const cargarPubicidadLicores = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === '' || numCaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setMostrarPublicidad(true);

  }

  const seleccionarFacturas = () => {
    console.log('paso 1')
    let campos = '*';
    let nomtab = 'factura';
    let fe = "'" + moment.utc(fechaSistema).format('YYYY-MM-DD') + "'";
    //let sta = 0;
    //let condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta} AND idfactura NOT IN (SELECT idfactura FROM ordenatenciondetalle WHERE fecha = ${fe})`;
    let condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND idfactura NOT IN (SELECT idfactura FROM ordenatenciondetalle WHERE fecha = ${fe})`;

    /*  if (radioFactu.current.checked) {
       condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
     } else {
       let letra = "'V'";
       condi = ` substring(numfactura, 1, 1) = ${letra} AND status = ${sta}`;
     } */

    let orden = '1';
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        let fact = [];
        //setFacturas(response.data);
        for (let i = 0; i < response.data.length; i++) {
          fact.push({
            idfactura: response.data[i].idfactura,
            numfactura: response.data[i].numfactura,
            idcontribuyente: response.data[i].idcontribuyente,
            totalinmpuesto: response.data[i].totalinmpuesto,
            totalrecargo: response.data[i].totalrecargo,
            totalinteres: response.data[i].totalinteres,
            idtipoingreso: response.data[i].idtipoingreso,
            fechaemision: response.data[i].fechaemision,
            descripcion: response.data[i].descripcion,
            tablacontribuyente: response.data[i].tablacontribuyente,
            tabladeuda: response.data[i].tabladeuda,
            iddeuda: response.data[i].iddeuda,
            status: response.data[i].status,
            nombrecontri: response.data[i].nombrecontri,
            direccioncontri: response.data[i].direccioncontri,
            cedrif: response.data[i].cedrif,
            totalmulta: response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta,
            deducible: response.data[i].deducible,
            facturador: response.data[i].facturador,
            totalfactura: parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo) + parseFloat(response.data[i].totalinteres)
              + parseFloat(response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta) - parseFloat(response.data[i].deducible),
            idcomercio: response.data[i].idcomercio,
            tipodeuda: response.data[i].tipodeuda

          })
        }
        setFacturas(fact);
      }
      setActivate(false);

    }).catch(function (error) {
      console.log(error)

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(function () {
      setActivate(false);
    });
  };

  const seleccionarNumAtencion = () => {
    console.log('paso 2')
    let numaten = txtNumAtencion.current.value;
    let fe = "'" + moment.utc(fechaSistema).format('YYYY-MM-DD') + "'";
    let llamado = '2';
    let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencion?numaten=${numaten}&fecha=${fe}&idusuario=${idusuario}&llamado=${llamado}`;
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        let fact = [];
        //setFacturas(response.data);
        for (let i = 0; i < response.data.length; i++) {
          fact.push({
            idfactura: response.data[i].idfactura,
            numfactura: response.data[i].numfactura,
            idcontribuyente: response.data[i].idcontribuyente,
            totalinmpuesto: response.data[i].totalinmpuesto,
            totalrecargo: response.data[i].totalrecargo,
            totalinteres: response.data[i].totalinteres,
            idtipoingreso: response.data[i].idtipoingreso,
            fechaemision: response.data[i].fechaemision,
            descripcion: response.data[i].descripcion,
            tablacontribuyente: response.data[i].tablacontribuyente,
            tabladeuda: response.data[i].tabladeuda,
            iddeuda: response.data[i].iddeuda,
            status: response.data[i].status,
            nombrecontri: response.data[i].nombrecontri,
            direccioncontri: response.data[i].direccioncontri,
            cedrif: response.data[i].cedrif,
            totalmulta: response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta,
            deducible: response.data[i].deducible,
            facturador: response.data[i].facturador,
            totalfactura: parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo) + parseFloat(response.data[i].totalinteres)
              + parseFloat(response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta) - parseFloat(response.data[i].deducible),
            idcomercio: response.data[i].idcomercio,
            tipodeuda: response.data[i].tipodeuda

          })
        }
        setFacturas(fact);
      }
      setActivate(false);

    }).catch(function (error) {
      console.log(error)

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(function () {
      setActivate(false);
    });
  };

  const seleccionarRegistro = () => {

    let numaten = txtNumAtencion.current.value.trim() === '' ? '0' : txtNumAtencion.current.value.trim();
    let campos = '*';
    let nomtab = 'ordenatencion';
    let fe = "'" + moment.utc(fechaSistema).format('YYYY-MM-DD') + "'";
    let condi = `numaten = ${numaten} AND fecha = ${fe}`;

    let orden = '1';
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {
          txtNumAtencion.current.value = response.data[0].numaten;
          seleccionarNumAtencion();
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El nùmero no existe.', icono: 'informacion' });
        }

      }


    }).catch(function (error) {
      console.log(error)

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(function () {
      setActivate(false);
    });
  };

  const handleAceptaFactura = () => {
    setMostrar(false);
    if (visibleNumAte === 'hidden') {
      seleccionarFacturas();
    } else {
      seleccionarNumAtencion();
    }

  }

  const handleAceptaFacturaPublicidad = () => {
    setMostrarPublicidad(false);
    if (visibleNumAte === 'hidden') {
      seleccionarFacturas();
    } else {
      seleccionarNumAtencion();
    }

  }

  const handleAceptaFacturaMulta = () => {
    setMostrarFacturaMulta(false);
    if (visibleNumAte === 'hidden') {
      seleccionarFacturas();
    } else {
      seleccionarNumAtencion();
    }

  }

  const handleAceptaFacturaTasa = () => {
    setMostrarTasasP(false);
    if (visibleNumAte === 'hidden') {
      seleccionarFacturas();
    } else {
      seleccionarNumAtencion();
    }

  }

  const handleAceptaOtroPago = () => {
    setMostrar2(false);
    if (visibleNumAte === 'hidden') {
      seleccionarFacturas();
    } else {
      seleccionarNumAtencion();
    }

  }

  const handleChangeRadio = (event) => {

    if (event.target.name === "radioTipo") {
      /*if (radioFactu.current.checked) {
        setActivo(false);
      } else if (radioVerifi.current.checked) {
        setActivo(true);
      }*/
    }

  };

  // const handleCloseMensa = () => {
  //   setMostrar1(false);
  // };

  const handleNumeroAtencion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    setFacturas([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro();
        radioReg.current.focus();
      }
    }
  };

  const editar = () => {
    setVisibleNunAte('visible');
  };

  const cancelar = () => {
    setVisibleNunAte('hidden');
    txtNumAtencion.current.value = '';
    radioReg.current.checked = true;
    radioEsp.current.checked = false;
    radioVip.current.checked = false;
    setFacturas([]);
  };

  const eliminarFactura = (ope) => {
    if (ope === 2) {
      seleccionarNumAtencion();
    } else {
      seleccionarFacturas();
    }
  };

  return (
    <div style={{height:'90dvh'}} className='col-12 m-0 p-0'>
      <div className='h-100 w-100 col-12 m-0 p-0 d-flex flex-wrap align-items-center'>
        <header className='col-12 mt-4 p-2 border d-md-none'>
          <a class="fw-bold px-2" 
            data-bs-toggle="offcanvas" 
            href="#menuFacturacion" 
            role="button" 
            aria-controls="menuFacturacion">
            Facturacion menu
          </a>
          <div class="offcanvas offcanvas-start" 
            style={{width:'200px'}}
            tabindex="-1" 
            id="menuFacturacion" 
            aria-labelledby="menuFacturacion">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasExampleLabel">MENU</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <nav className='offcanvas-body m-0 p-4 d-flex flex-column justify-content-center gap-2'>
            
              <a onClick={cargarpago('Inmuebles Urbanos', 1)} 
                className="border-bottom text-dark" 
                type="button">
                <i className="fas fa-home fa-fw me-3 second-text" />
                  Inmuebles Urbanos
              </a>
              <a onClick={cargarpago2('tasas', 'tasas', true)} 
                className="border-bottom text-dark" 
                type="button">
                <i className="fas fa-hard-hat me-2" />
                  Tasas
              </a>
            </nav> 
        </div>
        </header>
        <nav className='d-none d-md-flex h-screen col-4 col-md-3 m-0 p-0 px-4 flex-column justify-content-center gap-2'>
        
          <a onClick={cargarpago('Inmuebles Urbanos', 1)} 
            className="border-bottom text-dark" 
            type="button">
            <i className="fas fa-home fa-fw me-3 second-text" />
              Inmuebles Urbanos
          </a>
          <a onClick={cargarpago2('tasas', 'tasas', true)} 
            className="border-bottom text-dark" 
            type="button">
            <i className="fas fa-hard-hat me-2" />
              Tasas
          </a>
        </nav>
        {/* CONTENT */}
        <div className="col-12 col-md-9 m-0 p-4 p-md-0 pt-md-4 pr-md-4">
          <div className="col-12 m-0 p-0 shadow rounded">
            <header className='col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top'>
                <h3 class="m-0 fw-bold text-light">
                  Orden de Atención al Contribuyente
                </h3>
                <a type='button' 
                  className='text-light fw-bold fs-6'>
                  Salir <i className="fa fa-times ms-2"></i>
                </a>
            </header>
            <div className='col-12 m-0 p-2 d-flex align-items-center justify-content-between'>
              <span className='fw-bold'>
                Tipo Contribuyente:
              </span>
              <div className="col-auto m-0 p-0">
                <Radio label = 'Regular'
                  ref={radioReg} 
                  defaultChecked={true} 
                  name="radioTipo2" 
                  id="radioTipo1" 
                  onChange={handleChangeRadio} />
              </div>
              <div className="col-auto m-0 p-0">
                <Radio label = 'Especial'
                  ref={radioEsp} 
                  name="radioTipo2" 
                  id="radioTipo2" 
                  onChange={handleChangeRadio} />
              </div>
              <div className="col-auto m-0 p-0">
                <Radio label = 'VIP'
                  ref={radioVip} 
                  name="radioTipo2" 
                  id="radioTipo3" 
                  onChange={handleChangeRadio} />
              </div>
              <span className="fw-bold border rounded p-2">
                  Valor Euro:
                  <span className='fs-5'>
                    {' €'+formatMoneda(factorCambio.toString().replace(',', '').replace('.', ','), ',', '.', 2)}
                </span>
              </span>
            </div>
            <div class="col-4 m-0 p-2" style={{ display: visibleNumAte ? 'flex' : 'none' }}>
                <Input label = 'N° de llamado:'
                  ref={txtNumAtencion} 
                  onKeyUp={handleNumeroAtencion} 
                  onBlur={handleNumeroAtencion} 
                />
            </div>
            <PagosRegistros
              factorCambio={factorCambio}
              facturas={facturas}
              onHideRenderizar={seleccionarFacturas}
              onHideEdita={editar}
              onHideCancela={cancelar}
              onHideElimina={eliminarFactura}
              tipo={(radioReg.current && radioReg.current.checked === true) ? 1 : (radioEsp.current && radioEsp.current.checked === true) ? 2 : 3}
              natencion={visibleNumAte === 'visible' ? txtNumAtencion.current.value : '0'} />
          </div>
        </div>
      </div>
      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <FacturaPago show={mostrar} factorCambio={factorCambio} tipo={idtipoimpuesto} tipoImpuesto={tipoImpuesto} valor={valor}
        onHideCancela={() => setMostrar(false)}
        onHideAcepta={handleAceptaFactura}
      />
      <FacturaMultaPago show={mostrarFacturaMulta}
        onHideCancela={() => setMostrarFacturaMulta(false)}
        onHideAcepta={handleAceptaFacturaMulta}/>
      <TasasPagos
        show={mostarTasasP}
        tipo={0}
        onHideCancela={() => { setMostrarTasasP(false) }}
        onHideAcepta={handleAceptaFacturaTasa}
        factorCambio={factorCambio}/>
      <FacturaPublicidadPago tipo={idtipoimpuesto} tipoImpuesto={tipoImpuesto} valor={valor}
        show={mostrarPublicidad}
        onHideCancela={() => setMostrarPublicidad(false)}
        onHideAcepta={handleAceptaFacturaPublicidad}/>
      <OtrosImpuestos show={mostrar2} tipo={idtipoimpuestos} onHideCancelar={handleAceptaOtroPago} />
    </div>
  );
}
export default CajaIngresosCastatro;

